import LottieView from 'lottie-react-native';
import LottieWebView from 'react-native-web-lottie';
import { SafeAreaView, ScrollView, SxProp, View } from 'dripsy';
import React, { useRef, useState } from 'react';

import { Badge, BADGE_COLOR } from '@/design-system/components/badge/Badge';
import { CurrencySelector } from '@/design-system/components/currencySelector/CurrencySelector';
import { FONT_SIZE, H6, TextBody } from '@/design-system/components/typography';
import { PageContainer } from '@/features/earn/components/page/PageContainer';
import { PageItem } from '@/features/earn/components/page/PageItem';
import { DevToolsPageHeader } from '../components/DevToolsPageHeader';
import { DevToolsStackRoutes, DevToolsStackScreenProps } from '../types';
import { Tag, TAG_COLOR } from '@/design-system/components/tag/Tag';
import { TokenPagination } from '@/design-system/components/pagination/TokenPagination';
import { LastUpdated } from '@/design-system/components/lastUpdated/LastUpdated';
import { Slider } from '@/design-system/components/slider/Slider';
import { Tooltip } from '@/design-system/components/tooltip/Tooltip';
import { Icon } from '@/design-system/components/icons/Icon';

export const DevToolsOthers: React.FC<DevToolsStackScreenProps<DevToolsStackRoutes.Others>> = ({ navigation }) => {
  const [sliderValue, setSliderValue] = useState(0);
  const lottieRef = useRef<LottieView>(null);

  return (
    <SafeAreaView sx={styles.container}>
      <ScrollView showsVerticalScrollIndicator={false}>
        <PageContainer sx={{ paddingX: '$10', paddingY: '$10', backgroundColor: 'transparent' }}>
          <DevToolsPageHeader currentPage={DevToolsStackRoutes.Others} />
          {/* <Divider /> */}
          <View sx={{ flex: 1, gap: '$5', width: '100%' }}>
            <PageItem sx={{ padding: '$7', gap: '$5' }}>
              <H6 bold>CurrencySelector</H6>
              <CurrencySelector onValueChange={(value) => console.log('@CurrencySelector', value)} />
              <PageItem sx={{ padding: '$5' }}>
                <H6 semiBold>Usage</H6>
                <TextBody sx={{ fontFamily: 'monospace' }}>
                  {`
Default OPTIONS = ['USD', 'HKD'];

<CurrencySelector
  onValueChange={(value) => console.log('@CurrencySelector', value)} 
/>
`}
                </TextBody>
              </PageItem>
            </PageItem>
            {/* Badge */}
            <PageItem sx={{ padding: '$7', gap: '$5' }}>
              <H6 bold>Badge</H6>
              <Badge label="Badge" variant={FONT_SIZE.H6} />
              <Badge label="Badge" variant={FONT_SIZE.H6} color={BADGE_COLOR.BLUE} />
              <Badge label="Badge" variant={FONT_SIZE.H6} color={BADGE_COLOR.CYAN} />
              <Badge label="Badge" variant={FONT_SIZE.H6} color={BADGE_COLOR.GREY} />
              <Badge label="Badge" variant={FONT_SIZE.H6} color={BADGE_COLOR.GREEN} />
              <Badge label="Badge" variant={FONT_SIZE.H6} color={BADGE_COLOR.YELLOW} />
              <PageItem sx={{ padding: '$5' }}>
                <H6 semiBold>Usage</H6>
                <TextBody sx={{ fontFamily: 'monospace' }}>
                  {`
<Badge label="Badge" variant={FONT_SIZE.H6} />
<Badge label="Badge" variant={FONT_SIZE.H6} color={BADGE_COLOR.BLUE} />
<Badge label="Badge" variant={FONT_SIZE.H6} color={BADGE_COLOR.CYAN} />
<Badge label="Badge" variant={FONT_SIZE.H6} color={BADGE_COLOR.GREY} />
<Badge label="Badge" variant={FONT_SIZE.H6} color={BADGE_COLOR.GREEN} />
<Badge label="Badge" variant={FONT_SIZE.H6} color={BADGE_COLOR.YELLOW} />
`}
                </TextBody>
              </PageItem>
            </PageItem>
            {/* Tag */}
            <PageItem sx={{ padding: '$7', gap: '$5' }}>
              <H6 bold>Tag</H6>
              <Tag label="Badge" />
              <Tag label="Badge" tagColor={TAG_COLOR.BLUE} />
              <Tag label="Badge" tagColor={TAG_COLOR.CYAN} />
              <Tag label="Badge" tagColor={TAG_COLOR.RED} />
              <Tag label="Badge" tagColor={TAG_COLOR.GREEN} />
              <Tag label="Badge" tagColor={TAG_COLOR.YELLOW} />
              <Tag label="Badge" tagColor={TAG_COLOR.GREY} />
              <PageItem sx={{ padding: '$5' }}>
                <H6 semiBold>Usage</H6>
                <TextBody sx={{ fontFamily: 'monospace' }}>
                  {`
<Tag label="Badge" />
<Tag label="Badge" tagColor={TAG_COLOR.BLUE} />
<Tag label="Badge" tagColor={TAG_COLOR.CYAN} />
<Tag label="Badge" tagColor={TAG_COLOR.RED} />
<Tag label="Badge" tagColor={TAG_COLOR.GREEN} />
<Tag label="Badge" tagColor={TAG_COLOR.YELLOW} />
<Tag label="Badge" tagColor={TAG_COLOR.GREY} />
`}
                </TextBody>
              </PageItem>
            </PageItem>
            {/* Slider */}
            <PageItem sx={{ padding: '$7', gap: '$5' }}>
              <H6 bold>Slider</H6>
              <Slider
                minValue={0}
                maxValue={100}
                value={sliderValue}
                onValueChange={(value) => {
                  console.log('@Slider', value);
                  setSliderValue(value);
                }}
                step={1}
                disabled={false}
              />
              <Slider
                minValue={0}
                maxValue={100}
                value={sliderValue}
                onValueChange={(value) => {
                  console.log('@Slider', value);
                  setSliderValue(value);
                }}
                step={1}
                disabled={true}
              />
              <PageItem sx={{ padding: '$5' }}>
                <H6 semiBold>Usage</H6>
                <TextBody sx={{ fontFamily: 'monospace' }}>
                  {`
<Slider
  minValue={0}
  maxValue={100}
  value={sliderValue}
  onValueChange={(value) => {
    console.log('@Slider', value);
    setSliderValue(value);
  }}
  step={1}
  disabled={false}
/>
`}
                </TextBody>
              </PageItem>
            </PageItem>

            {/* PAGINATION */}
            <PageItem sx={{ padding: '$7', gap: '$5' }}>
              <H6 bold>Pagination</H6>
              <TokenPagination
                prevPageToken="prevPageToken"
                nextPageToken="nextPageToken"
                onPrevPage={() => console.log('@onPrevPage')}
                onNextPage={() => console.log('@onNextPage')}
              />
              <TokenPagination prevPageToken="prevPageToken" onPrevPage={() => console.log('@onPrevPage')} />
              <TokenPagination nextPageToken="nextPageToken" onNextPage={() => console.log('@onNextPage')} />
              <PageItem sx={{ padding: '$5' }}>
                <H6 semiBold>Usage</H6>
                <TextBody sx={{ fontFamily: 'monospace' }}>
                  {`
<TokenPagination
  prevPageToken="prevPageToken"
  nextPageToken="nextPageToken"
  onPrevPage={() => console.log('@onPrevPage')}
  onNextPage={() => console.log('@onNextPage')}
/>
<TokenPagination prevPageToken="prevPageToken" onPrevPage={() => console.log('@onPrevPage')} />
<TokenPagination nextPageToken="nextPageToken" onNextPage={() => console.log('@onNextPage')} />
`}
                </TextBody>
              </PageItem>
            </PageItem>

            {/* LAST UPDATED */}
            <PageItem sx={{ padding: '$7', gap: '$5' }}>
              <H6 bold>Last Updated</H6>
              <LastUpdated dateTime={new Date().toISOString()} />
              <PageItem sx={{ padding: '$5' }}>
                <H6 semiBold>Usage</H6>
                <TextBody sx={{ fontFamily: 'monospace' }}>
                  {`
<LastUpdated dateTime={new Date().toISOString()} />
`}
                </TextBody>
              </PageItem>
            </PageItem>

            {/* TOOLTIP */}
            <PageItem sx={{ padding: '$7', gap: '$5' }}>
              <H6 bold>Tooltip</H6>
              <View sx={{ flexDirection: 'row', gap: '$3' }}>
                <Tooltip
                  content="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id condimentum mauris, eget viverra libero. Quisque at dictum urna. Nunc id vulputate risus. In diam erat, sodales nec tortor ut, ornare sollicitudin quam. Aliquam erat volutpat."
                  position="left"
                  contentTextMinWidth={200}>
                  <LastUpdated dateTime={new Date().toISOString()} />
                </Tooltip>
                <Tooltip content={<LastUpdated dateTime={new Date().toISOString()} />} position="middle" showUnderline={false}>
                  <Icon name="infoCircle" />
                </Tooltip>
                <Tooltip content={<LastUpdated dateTime={new Date().toISOString()} />} position="right" showUnderline={false}>
                  <Icon name="infoCircle" />
                </Tooltip>
              </View>
              <PageItem sx={{ padding: '$5' }}>
                <H6 bold>Usage</H6>
                <TextBody sx={{ fontFamily: 'monospace' }}>
                  {`
<Tooltip
  position="left"
  content="Lorem ipsum dolor..."
  contentTextMinWidth={200}>
  <LastUpdated dateTime={new Date().toISOString()} />
</Tooltip>
<Tooltip content={<LastUpdated dateTime={new Date().toISOString()} />} position="middle">
  <Icon name="infoCircle" />
</Tooltip>
<Tooltip content={<LastUpdated dateTime={new Date().toISOString()} />} position="right">
  <Icon name="infoCircle" />
</Tooltip>
`}
                </TextBody>
              </PageItem>
            </PageItem>

            {/* Lottie */}
            <PageItem sx={{ padding: '$7', gap: '$5' }}>
              <H6 bold>Lottie</H6>
              <View sx={{ flexDirection: 'row', gap: '$3' }}>
                {/* <LottieView
                  ref={lottieRef}
                  source={require('../../../assets/lottie/cloud-upload.json')}
                  autoPlay
                  loop
                  style={{
                    width: 100,
                    height: 100
                  }}
                /> */}
                <LottieWebView
                  ref={lottieRef}
                  source={require('../../../assets/lottie/cloud-upload.json')}
                  autoPlay
                  loop
                  style={{
                    width: 100,
                    height: 100
                  }}
                />
              </View>
              <PageItem sx={{ padding: '$5' }}>
                <H6 bold sx={{ justifyContent: 'center' }}>
                  Usage <Badge label="App" variant={FONT_SIZE.textBody} color={BADGE_COLOR.YELLOW} />{' '}
                </H6>
                <TextBody sx={{ fontFamily: 'monospace' }}>
                  {`
import LottieView from 'lottie-react-native';

<LottieView source={require('../assets/lottie/cloud-upload.json')} autoPlay loop />
`}
                </TextBody>
              </PageItem>
              <PageItem sx={{ padding: '$5' }}>
                <H6 bold sx={{ justifyContent: 'center' }}>
                  Usage <Badge label="Web" variant={FONT_SIZE.textBody} color={BADGE_COLOR.BLUE} />
                </H6>
                <TextBody sx={{ fontFamily: 'monospace' }}>
                  {`
import LottieWebView from 'react-native-web-lottie';

<LottieWebView source={require('../assets/lottie/cloud-upload.json')} autoPlay loop />
`}
                </TextBody>
              </PageItem>
            </PageItem>
          </View>
        </PageContainer>
      </ScrollView>
    </SafeAreaView>
  );
};

enum StyleName {
  container = 'container',
  pageItem = 'pageItem'
}

const styles: Record<StyleName, SxProp> = {
  container: {},
  pageItem: {
    width: 250,
    padding: '$7',
    borderRadius: 10,
    gap: '$2'
  }
};
